var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Drawer as ChakraDrawer, DrawerBody as ChakraDrawerBody, DrawerFooter as ChakraDrawerFooter, DrawerHeader as ChakraDrawerHeader, DrawerOverlay as ChakraDrawerOverlay, DrawerContent as ChakraDrawerContent, DrawerCloseButton as ChakraDrawerButton, } from "@chakra-ui/react";
import { pick, Size } from "../../core";
export const DrawerSize = pick(Size, ["xs", "sm", "md", "lg", "xl", "full"]);
/**
 * The Drawer component is a panel that slides out from the edge of the screen.
 * It can be useful when you need users to complete a task or view some details without leaving the current page.
 */
export function Drawer(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return React.createElement(ChakraDrawer, Object.assign({}, rest), children);
}
export function DrawerBody(props) {
    return React.createElement(ChakraDrawerBody, Object.assign({}, props));
}
export function DrawerFooter(props) {
    return React.createElement(ChakraDrawerFooter, Object.assign({ borderTopWidth: "1px" }, props));
}
export function DrawerHeader(props) {
    return React.createElement(ChakraDrawerHeader, Object.assign({ borderBottomWidth: "1px" }, props));
}
export function DrawerContent(props) {
    return React.createElement(ChakraDrawerContent, Object.assign({}, props));
}
export function DrawerCloseButton(props) {
    return React.createElement(ChakraDrawerButton, Object.assign({}, props));
}
export function DrawerOverlay(props) {
    return React.createElement(ChakraDrawerOverlay, Object.assign({}, props));
}
Drawer.displayName = "Drawer";
export default Drawer;
//# sourceMappingURL=Drawer.js.map